import React, { useState, useEffect } from "react";
import axios from "axios";
import "./style.css";
import Header from "../../components/header";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export default function Privacy() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    const fetchPrivacy = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/privacy-terms/privacy`);
        setContent(response.data.content);
        setLastUpdated(response.data.lastUpdated);
      } catch (error) {
        console.error("Error fetching privacy policy:", error);
        // Fallback to default content if API fails
        setContent(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacy();
  }, []);

  // Default content fallback
  const defaultContent = `
    <section class="privacy_section">
      <h2>1. Information We Collect</h2>
      <div class="section_content">
        <p>At UsmaApp, we are committed to protecting your privacy. We collect information to provide better services to all our users.</p>
        <h3>Information you provide to us:</h3>
        <ul>
          <li>Profile information (name, email, profile picture)</li>
          <li>Content you create and share (posts, photos, videos, comments)</li>
          <li>Messages and communications with other users</li>
          <li>Feedback</li>
        </ul>
      </div>
    </section>
    <section class="privacy_section">
      <h2>2. How We Use Your Information</h2>
      <div class="section_content">
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide, maintain, and improve our services</li>
          <li>Connect you with friends and other users</li>
          <li>Personalize your experience and content recommendations</li>
          <li>Communicate with you about our services</li>
        </ul>
      </div>
    </section>
    <section class="privacy_section">
      <h2>3. Information Sharing</h2>
      <div class="section_content">
        <p>We respect your privacy and do not sell your personal information. We may share information in the following circumstances:</p>
        <ul>
          <li><strong>With your consent:</strong> When you explicitly agree to share information</li>
          <li><strong>With other users:</strong> Information you choose to make public or share</li>
          <li><strong>Service providers:</strong> With trusted partners who help us operate our services</li>
        </ul>
      </div>
    </section>
    <section class="privacy_section">
      <h2>4. Your Privacy Controls</h2>
      <div class="section_content">
        <p>You have control over your information and privacy settings:</p>
        <ul>
          <li><strong>Profile Settings:</strong> Control who can see your profile and posts</li>
          <li><strong>Privacy Settings:</strong> Manage your privacy preferences in settings</li>
          <li><strong>Data Deletion:</strong> Request deletion of your account and data</li>
          <li><strong>Communication Preferences:</strong> Control notifications and communications</li>
        </ul>
      </div>
    </section>
    <section class="privacy_section">
      <h2>5. Children's Privacy</h2>
      <div class="section_content">
        <p>UsmaApp is not intended for children under 18 years of age. We do not knowingly collect personal information from children under 18. If we become aware that we have collected personal information from a child under 18, we will take steps to delete such information.</p>
      </div>
    </section>
    <section class="privacy_section">
      <h2>6. Changes to This Policy</h2>
      <div class="section_content">
        <p>We may update this privacy policy from time to time. We will notify you of any material changes by:</p>
        <ul>
          <li>Posting the new policy on this page</li>
          <li>Sending you a notification through the platform</li>
          <li>Updating the "Last updated" date at the top of this policy</li>
        </ul>
      </div>
    </section>
       <section className="terms_section">
              <h2>7. Contact Information</h2>
              <div className="section_content">
                <p>If you have questions about these Terms of Service, please contact us:</p>
                <div className="contact_info">
                  <p><strong>Support:</strong> support@usmaapp.com</p>
                </div>
              </div>
            </section>
          </div>
  `;

  if (loading) {
    return (
      <div className="privacy_page">
        <Header />
        <div className="privacy_container">
          <div className="privacy_content">
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="privacy_page">
      <Header />
      <div className="privacy_container">
        <div className="privacy_content">
          <div className="privacy_header">
            <h1>UsmaApp Privacy Policy</h1>
            {lastUpdated && (
              <p className="last_updated">
                Last updated: {new Date(lastUpdated).toLocaleDateString()}
              </p>
            )}
          </div>

          <div className="privacy_sections" dangerouslySetInnerHTML={{ __html: content || defaultContent }}></div>

          <div className="privacy_footer">
            <p><strong>UsmaApp</strong> - Connecting people, protecting privacy.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
